import React, { Component } from 'react';
import { Provider } from 'react-redux';
import App from '../App';
import configureStore from "./configureStore";

export default class Root extends Component {
  render() {
    return (
      <Provider store={configureStore()}>
        <App/>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/boilerplate/Root.prod.js